import React from "react";
import { Link } from "react-router-dom";

const Wellcome = ({ history }) => {
  return (
    <React.Fragment>
      <div className="app-pages">
        <i
          style={{ fontSize: "32px", marginLeft: "18px", marginBottom: "15px" }}
          class="material-icons dp48"
          onClick={() => {
            history.push("/");
            return false;
          }}
        >
          arrow_back
        </i>
        <div className="had-container">
          <div className="survey-section-welcome">
            <p className="survey-title-welcome">
              Welcome to the COVID-19 Self Assessment Tool
            </p>
            <p className="survey-text-wellcome">
              This tool is not meant to take the place of consultation with your
              health care provider or to diagnose or treat conditions. If you're
              in an emergency medical situation, call 911 or your local
              emergency number.
            </p>
            <p className="survey-text-wellcome">
              This tool does not track personal information.
            </p>
          </div>
          <div className="row center" style={{ paddingTop: "100px" }}>
            <Link
              to="/survey"
              className="waves-effect waves-light survey-welcome-button"
            >
              Begin Assessment
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Wellcome;
